import { distize } from './distize'

export { copySourceFiles } from './copy-source-files'
export { copyNodeModules } from './copy-node-modules'
export { distize } from './distize'

export default distize
